module.exports = __webpack_public_path__ + "img/img-transfer-bg.dd03b099.png";